var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"episodes-section py-10 bg-cover bg-blue-dark",style:({
        backgroundImage: ("url(" + _vm.bgImage + ")"),
        backgroundColor: _vm.backgroundColor
    })},[_c('h2',{staticClass:"font-primary text-4xl text-white text-center"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"w-full"},[_c('slider',{attrs:{"options":_vm.sliderOptions,"items":_vm.episodes},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var episode = ref.item;
    var index = ref.index;
return [_c('episode',{attrs:{"episode":episode,"episodes":_vm.episodes,"index":index}})]}}])})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }